export enum LocationsLegacyIds {
  HAYWARD = 1,
  BROOKLYN = 4,
  REDMOND = 6,
  AUSTIN = 7,
  MIAMI = 9,
  QUEEN_CITY = 14,
  ALTO_AUSTIN = 24,
  HAMILTON = 11,
  HAMILTON_2 = 19,
  SEVEN_HILLS = 20,
  HAMILTON_3 = 21,
}

export enum Org {
  Alto = 'ALTO',
  Truepill = 'TRUEPILL',
  LetsGetChecked = 'LETS GET CHECKED',
}
